import Vue from 'vue'
import vuetify from './plugins/vuetify';
import './plugins/vue-progressbar'
import i18n from './plugins/vueI18n'
import './plugins/vue-currency-filter'
import './plugins/vue-moment'
import './plugins/vue-sweetalert2'
import './plugins/v-mask'
import './plugins/style';
import './plugins/vue-events'
import './plugins/csp-component'
import './plugins/draggable-dialog'
// import './plugins/vue-google-oauth2'
import './plugins/vue-js-toggle-button'
import './plugins/vue-json-excel';
import '@mdi/font/css/materialdesignicons.css'
import './plugins/vue-date-time-picker'
import './plugins/vue-youtube'
// import './plugins/vue-socket-io'
import './plugins/portal-vue'
import './Filter/USPhoneNumber'
// import './Filter/highlight.js'
// import VueGtag from "vue-gtag";
import UtilsPlugin from './plugins/utilsPlugin';

import VueSocketIO from "vue-socket.io";
import SocketIO from "socket.io-client";
// import SocketIO from "socket.io-client";

import App from './App.vue'
import router from './router';
import store from './plugins/vuex'

import './registerServiceWorker';

Vue.use(UtilsPlugin);
// Vue.use(VueGtag, {
//   config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS }  
// },router);

// Vue.use(VueGtag, {
//   id: process.env.VUE_APP_GOOGLE_ANALYTICS,
//   router,
//   debug: {
//     enabled: false,
//     sendHitTask: false,
//   },
// });

const API_KEY = process.env.VUE_APP_SERVER_API_KEY || localStorage.getItem("x-clientid");

Vue.use(
  new VueSocketIO({
    debug: process.env.NODE_ENV !== "production",
    connection: SocketIO(process.env.VUE_APP_SERVER_URL, {
      withCredentials: true, // Ensure credentials are sent
      transports: ["websocket", "polling"],
      extraHeaders: {
        "x-clientid": API_KEY, // Send API Key
      },
    }),
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_",
    },
  })
);

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  i18n,
  store,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("render-event")),
}).$mount('#app')
